export default  {
    knobX: 84,
    knobY: 84,
    svg:`
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="208px" height="208px" viewBox="0 0 208 208" version="1.1">
    <!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->
    <desc>Created with Sketch.</desc>
    <defs>
        <linearGradient x1="50%" y1="50%" x2="50%" y2="100%" id="d4824b67-e7b2-b4bf-5137-197630aa4ed5">
            <stop stop-color="#FFFFFF" stop-opacity="0.5" offset="0%"/>
            <stop stop-color="#000000" stop-opacity="0.5" offset="100%"/>
        </linearGradient>
        <circle id="741fc270-ebe5-a010-74ce-ebd5b6219d6a" cx="100" cy="100" r="100"/>
        <filter x="-3.5%" y="-3.0%" width="107.0%" height="107.0%" filterUnits="objectBoundingBox" id="80411186-812d-21fd-8861-0f6cd9b27afc">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="1" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
        <circle id="13361ce4-fe49-0c64-cd31-d672e3f9118b" cx="100" cy="100" r="88"/>
        <filter x="-4.0%" y="-3.4%" width="108.0%" height="108.0%" filterUnits="objectBoundingBox" id="b0d9b9fb-b843-8a72-cda2-001561b62b05">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="1" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="d0f875cc-73d5-5659-c237-b18d87dd48cb">
            <stop stop-color="#EEEEEE" offset="0%"/>
            <stop stop-color="#EDEDED" offset="50.0553592%"/>
            <stop stop-color="#D8D8D8" offset="100%"/>
        </linearGradient>
        <circle id="46a77a59-f749-e170-912b-75516f556d09" cx="84" cy="84" r="84"/>
        <filter x="-4.2%" y="-3.6%" width="108.3%" height="108.3%" filterUnits="objectBoundingBox" id="5644e3cb-b16e-2717-0186-2bec9685d236">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="1" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
        <circle id="23968c88-aa6f-4cc1-7efe-2d02b026fe94" cx="84" cy="84" r="60"/>
        <filter x="-2.1%" y="-2.1%" width="104.2%" height="104.2%" filterUnits="objectBoundingBox" id="50b8d98e-8160-e689-e364-183bab594b06">
            <feGaussianBlur stdDeviation="1.5" in="SourceAlpha" result="shadowBlurInner1"/>
            <feOffset dx="0" dy="1" in="shadowBlurInner1" result="shadowOffsetInner1"/>
            <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowInnerInner1"/>
        </filter>
        <radialGradient cx="50%" cy="50%" fx="50%" fy="50%" r="41.8108259%" id="b1bf778e-5f58-fe3b-f738-56f913e8bfc4">
            <stop stop-color="#3D3D3D" offset="0%"/>
            <stop stop-color="#979191" offset="100%"/>
        </radialGradient>
        <circle id="f4e451a3-c0d7-4c47-0484-44a79c236883" cx="84" cy="11" r="10"/>
        <filter x="-10.0%" y="-10.0%" width="120.0%" height="120.0%" filterUnits="objectBoundingBox" id="be5315db-a3ce-9088-9950-d98dc838dfca">
            <feGaussianBlur stdDeviation="1.5" in="SourceAlpha" result="shadowBlurInner1"/>
            <feOffset dx="0" dy="1" in="shadowBlurInner1" result="shadowOffsetInner1"/>
            <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowInnerInner1"/>
        </filter>
        <circle id="e3f8d236-d8c8-de06-6bac-edc7f421bb55" cx="84" cy="11" r="7.48293949"/>
        <filter x="-20.0%" y="-20.0%" width="140.1%" height="140.1%" filterUnits="objectBoundingBox" id="082b542c-f053-8f21-f490-22d5729e8bf8">
            <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0.31372549   0 0 0 0 0.890196078   0 0 0 0 0.760784314  0 0 0 1 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
        
        <filter x="-6.6%" y="-14.0%" width="113.2%" height="127.9%" filterUnits="objectBoundingBox" id="97a9bdac-089d-eb1b-136d-0e5296127f24">
            <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0.635294118   0 0 0 0 0.780392157   0 0 0 0 0.949019608  0 0 0 1 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="s8" transform="translate(4.000000, 3.000000)">
            <g id="container">
                <g id="Oval-2">
                    <use fill="black" fill-opacity="1" filter="url(#80411186-812d-21fd-8861-0f6cd9b27afc)" xlink:href="#741fc270-ebe5-a010-74ce-ebd5b6219d6a"/>
                    <use stroke="#979797" stroke-width="1" fill="url(#d4824b67-e7b2-b4bf-5137-197630aa4ed5)" fill-rule="evenodd" xlink:href="#741fc270-ebe5-a010-74ce-ebd5b6219d6a"/>
                </g>
                <g id="Oval-2">
                    <use fill="black" fill-opacity="1" filter="url(#b0d9b9fb-b843-8a72-cda2-001561b62b05)" xlink:href="#13361ce4-fe49-0c64-cd31-d672e3f9118b"/>
                    <use stroke="#4A4A4A" stroke-width="1" fill="#4A4A4A" fill-rule="evenodd" xlink:href="#13361ce4-fe49-0c64-cd31-d672e3f9118b"/>
                </g>
                <g id="knob" transform="translate(16.000000, 16.000000)">
                    <g id="Oval-2">
                        <use fill="black" fill-opacity="1" filter="url(#5644e3cb-b16e-2717-0186-2bec9685d236)" xlink:href="#46a77a59-f749-e170-912b-75516f556d09"/>
                        <use stroke="#979797" stroke-width="1" fill="url(#d0f875cc-73d5-5659-c237-b18d87dd48cb)" fill-rule="evenodd" xlink:href="#46a77a59-f749-e170-912b-75516f556d09"/>
                    </g>
                    <g id="Oval">
                        <use fill="#3D3D3D" fill-rule="evenodd" xlink:href="#23968c88-aa6f-4cc1-7efe-2d02b026fe94"/>
                        <use fill="black" fill-opacity="1" filter="url(#50b8d98e-8160-e689-e364-183bab594b06)" xlink:href="#23968c88-aa6f-4cc1-7efe-2d02b026fe94"/>
                        <use stroke="#454545" stroke-width="1" xlink:href="#23968c88-aa6f-4cc1-7efe-2d02b026fe94"/>
                    </g>
                    <g id="Oval-3">
                        <use fill="url(#b1bf778e-5f58-fe3b-f738-56f913e8bfc4)" fill-rule="evenodd" xlink:href="#f4e451a3-c0d7-4c47-0484-44a79c236883"/>
                        <use fill="black" fill-opacity="1" filter="url(#be5315db-a3ce-9088-9950-d98dc838dfca)" xlink:href="#f4e451a3-c0d7-4c47-0484-44a79c236883"/>
                    </g>
                    <g id="Oval-4">
                        <use fill="black" fill-opacity="1" filter="url(#082b542c-f053-8f21-f490-22d5729e8bf8)" xlink:href="#e3f8d236-d8c8-de06-6bac-edc7f421bb55"/>
                        <use fill="#3D3D3D" fill-rule="evenodd" xlink:href="#e3f8d236-d8c8-de06-6bac-edc7f421bb55"/>
                    </g>
                </g>
                <g id="label" transform="translate(55.000000, 79.000000)" fill="#A3C8F4" fill-opacity="1">
                    <g id="labeltext">
                        <text id="38766162-6040-9770-2fd4-8a915ebb8d59" font-family="Helvetica" font-size="36" font-weight="normal" fill="#A3C8F4" class="text-16" filter="url(#97a9bdac-089d-eb1b-136d-0e5296127f24)">
            <tspan x="15.7177734" y="35">100</tspan>
        </text>
                        <text id="86f91a54-8d70-edcd-a3a5-865c8651a352" font-family="Helvetica" font-size="36" font-weight="normal" fill="#A3C8F4" class="text-16">
            <tspan x="15.7177734" y="35">100</tspan>
        </text>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
`,
updateAttributes: [
    {
      element: "#labeltext text tspan",
      content: (props, value) => {
        return value.toFixed(0);
      },
      attrs: [
        {
          name: "text-anchor",
          value: (props, value) => {
            return "middle";
          }
        },
        {
          name: "x",
          value: (props, value) => {
            return "43";
          }
        }
      ]
    }
  ]
}